import { Schemas } from '~/api/gen'
import { Chip } from '~/components/elements/Chip'
import {
  buildBodyFrameTypeChipProps,
  buildGenderAgeHeightChipProps,
  buildHairStyleChipProps,
} from '~/features/shared/member/lib/buildChipProps'
import { sexToGender } from '~/lib/gender/converter'
import { Base } from './ChipList/Base'

type Props = {
  coordinate: Schemas.coordinate_large_with_member_shop_brands
}

export const ModelInfo: React.FC<Props> = ({ coordinate }) => {
  const gender = sexToGender(coordinate.sex_id)
  const chipProps = [
    buildGenderAgeHeightChipProps(
      gender,
      coordinate.age ?? undefined,
      coordinate.height ?? undefined
    ),
    buildBodyFrameTypeChipProps(coordinate.body_frame_type ?? undefined),
    buildHairStyleChipProps(coordinate.hair_style ?? undefined),
  ].filter((props) => props !== undefined)

  if (chipProps.length === 0) return null
  return (
    <Base title="モデル情報">
      {chipProps.map((props) => (
        <li key={props.children}>
          <Chip {...props} />
        </li>
      ))}
    </Base>
  )
}
